const env: any = process.env.VUE_APP_BLUE_DOT;
const suffix: any = env === 'develop' ? `（测试）` : ``;
const routers: any[] = [
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/',
		name: 'home',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import(/* webpackChunkName: "home" */ '@/views/home.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/list-class',
		name: 'list',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/listclass.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/list',
		name: 'list',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/list.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/industrylist',
		name: 'industrylist',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/industrylist.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/industrydetails',
		name: 'industrydetails',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/industrydetails.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/cibf',
		name: 'cibf',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/cibf-bak.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/cibf-list',
		name: 'cibf-list',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/cibflist.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/cibf-bak',
		name: 'cibf-bak',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/cibf-bak.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/details',
		name: 'details',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/details.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/video',
		name: 'video',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/video.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/post-ls',
		name: 'post-ls',
		meta: {
			// keepAlive: true,// 是否需要开启页面缓存
			wechatAuth: true, // 是否开启微信授权

			// 注意改示例是关闭了页面监测
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/postlockstar.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/sample',
		name: 'sample',
		meta: {
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/sample.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/samplerecord',
		name: 'samplerecord',
		meta: {
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/samplerecord.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/sampledetail',
		name: 'sampledetail',
		meta: {
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/sampledetail.vue')
	},
	{
		title: '赢创即用型3D打印材料' + suffix,
		path: '/sampleform',
		name: 'sampleform',
		meta: {
			wechatAuth: true, // 是否开启微信授权
			closeMonitorView: true // 是否关闭页面浏览监测，自定义页面标题使用
		},
		component: () => import('@/views/sampleform.vue')
	}
];

export default routers;
